import { formatDistanceToNow } from 'date-fns'

export const notificationTimeAgo = (dateString: string) =>
  `${formatDistanceToNow(new Date(dateString))} ago`
